// @flow
import { fetch, fetchSolaris } from '../../api';
import { fetchFeed } from './general';

export function fetchPosts(
  feed: Object,
  queries: Object = {},
  from: number = 0,
  pageSize: number = 20) {
  const pageNumber = Math.ceil(from / pageSize) + 1;

  const fetchData = async function fetchData() {
    const { payload } = await fetch('posts', { query: { ...queries, pageNumber, pageSize } });
    const { users, posts, ratings } = payload;
    // @FIXME HACK groups of payload ignore cause data is busted.
    return { data: { users, posts, ratings } };
    // @FIXME HACK groups of payload ignore cause data is busted.
  };

  return fetchFeed(feed, from === 0, fetchData);
}

export function fetchOnboardingGroups(
  feed,
  optionIds = [],
  countryCode = 'GB'
) {
  const fetchData = async function fetchData() {
    const { communities } = await fetchSolaris('onboarding/communities', { query: { optionIds, countryCode } });
    return { data: { groups: communities } };
  };
  return fetchFeed(feed, true, fetchData);
}



// WEBPACK FOOTER //
// ./~/virgo/src/actions/feedActionsCreator/group.js